import React, {useContext, useEffect, useRef, useState} from 'react';
import DeleteIcon from '../../../assests/img/delete-icon.svg?react';
import Popup from './Popup';
import TextInput from './TextInput';
import Button from './Button';
import {addFilterApi} from '../api/postApi';
import {FilterContext, initialValues} from '../context/filterContext';
import {UserContext} from '../context/userContext';
import {toast} from 'react-toastify';
import {updateDataApi} from '../api/updateApi';
import classNames from 'classnames';
import {deleteDataApi} from '../api/deleteApi';
import {getDataApi} from '../api/getApiData';
import {contructGetFilterQuery} from '../functions/contructQuery';
import {AuthContext} from '../context/authContext';
import '../../../assests/css/view.scss';
import Tooltip from './Tooltip';

export interface viewType {
    id: number,
    name: string,
    content: string,
    userId: number,
    createdById: number
}

export interface viewProps {
    disable?: boolean
}

export default function View(props: viewProps) {

    const {disable} = props;

    const dropdownRef = useRef<HTMLDivElement>(null);
    const {filterContent, setFilterContent} = useContext(FilterContext);
    const {data} = useContext(UserContext);
    const {accounts} = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [views, setViews] = useState<viewType[]>([]);
    const [addFilter, setAddFilter] = useState(false);
    const [filterName, setFilterName] = useState('');
    const [filterApplied, setFilterApplied] = useState({id: 0, name: ''});
    const [hovered, setHovered] = useState(0);
    const [deleteId, setDeleteId] = useState(0);
    const [isFilterApplied, setIsFilterApplied] = useState(false);


    const getViews = async () => {
        const res = await getDataApi(`Filter?$filter=userId eq ${data.userId}`,
            accounts);
        setViews(res);
    }

    const getFilterToSave = () => {
        return JSON.stringify({...filterContent, search: '', favourites: []});
    }

    const handleSaveView = async () => {
        if (isFilterApplied) {
            if (filterName.trim().length !== 0) {
                setLoading(true);
                const reqData = {
                    name: filterName,
                    content: getFilterToSave(),
                    userId: data.userId,
                    createdById: data.userId,
                }
                const res = await toast.promise(addFilterApi(reqData,
                    accounts), {
                    pending: 'Saving filter'
                });
                if (res.status === 201) {
                    toast.success("Filter has been successfully saved!");
                    getViews();
                }
                setAddFilter(false);
                setLoading(false);
                setFilterName('');
            } else {
                toast.error("Please enter a filter name");
            }
        }
    }

    const handleDeleteClick = async (e: React.MouseEvent<SVGSVGElement,
            MouseEvent>, id: number) => {
        e.stopPropagation();
        setDeleteId(id);
    }

    const handleDeleteView = async (id: number) => {
        setDeleteId(0);
        const res = await toast.promise(deleteDataApi(`Filter/id/${id}`,
            accounts), {
            pending: 'Deleting filter',
        });
        if (res === 204) {
            toast.success("Filter deleted succssfullly");
            getViews();
        } else {
            toast.error(`Filter delete failed: ${res.data.error.message}`);
        }
    }

    const handleApplyView = (id: number) => {
        const viewSelected = views.filter((view)=> view.id === id);
        if (viewSelected.length) {
            const selected = viewSelected[0];
            setFilterContent(JSON.parse(selected.content));
            setFilterApplied({id: selected.id, name: selected.name});
            setShowDropdown(false);
        }
    }

    const handleClickOutside=(event: MouseEvent)=> {
        if (dropdownRef.current &&
            !dropdownRef.current.contains(event.target as Node)) {
            setShowDropdown(false);
        }
    }

    const handleSaveExistingView = async () => {
        if (isFilterApplied) {
            setLoading(true);
            if (filterApplied.id !== 0) {
                const reqBody = {
                    content: getFilterToSave(),
                    UpdatedById: data.userId,
                }
                const res = await toast.promise(updateDataApi(`Filter/id/${filterApplied.id}`,
                    reqBody, accounts), {pending: 'Updating filter'});
                if (res === 200) {
                    toast.success("Updated filter sucessfully");
                } else {
                    toast.error(`Error updating filter: ${res.data.error.message}`);
                }
                getViews();
                setLoading(false);
            } else {
                setLoading(false);
                setAddFilter(true);
            }
        }
    }

    const clearView = () => {
        setFilterContent({...initialValues, favourites: null});
        setFilterApplied({id: 0, name: ''});
    }

    useEffect(() => {
        const {filterCount} = contructGetFilterQuery(filterContent);
        if (filterCount === 0) {
            setIsFilterApplied(false);
        } else {
            setIsFilterApplied(true);
        }
    }, [filterContent]);

    useEffect(()=> {
        document.addEventListener("mousedown", handleClickOutside);
        getViews();
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [
    ]);

    return (
        <>
        <Popup title='Filter Name' onClose={()=> setAddFilter(false)}
            show={addFilter} size='lg'
            customClassName='manage-user-menu-popup'>
            <div className="view-add-container">
                <TextInput type='text' placeholder='Enter Filter Name Here'
                    text={filterName} onChange={(text)=>
                        text.length<=20? setFilterName(text): null}
                    className='view-name-text-input'/>
                <div className="view-add-controls">
                    <Button type='primary' onClick={handleSaveView} buttonText='Save'
                        loading={loading}/>
                    <Button type='secondary'
                        onClick={()=> setAddFilter(false)} buttonText='Cancel'/>
                </div>
            </div>
        </Popup>
        {deleteId !==0?
        <Popup
            show={deleteId !== 0}
            onClose={() => setDeleteId(0)}
            title='Are you sure you want to delete this filter?'
            size='lg'
            primaryCtaText='Delete'
            primaryCtaOnClick={() => handleDeleteView(deleteId)}
            secondaryCtaText='Cancel'
            secondaryCtaOnClick={() => setDeleteId(0)}
            customClassName='manage-user-menu-popup'/>: null}
        <div className={classNames('view-container',
            disable? 'disable-filter': '')}>
            <div className={classNames('view-select',
                filterApplied.id !== 0? 'filter-applied': '',
                disable? 'disable-filter': '')}
                onClick={disable? ()=> null: ()=> setShowDropdown(true)}>
                <Tooltip text={filterApplied.name}>
                    <span className="view-options">Filters</span>
                </Tooltip>
                <span className="view-options-arrow"/>
                {showDropdown?
                <div className="view-dropdown-container" ref={dropdownRef}>
                    <div className="view-dropdown-controls">
                        <div className="view-dropdown-control-container
                                view-filter-text">
                            <span className={classNames(
                                'view-dropdown-control',
                                !isFilterApplied? 'filter-no-action': '',
                                disable? 'disable-filter': '')}
                                onClick={disable?
                                    ()=> null:handleSaveExistingView}>
                                Save Filter
                            </span>
                            {loading? <span className="edit-loader"/>: null}
                        </div>
                        <div className="view-dropdown-control-container">
                            <span className="view-dropdown-seperator"/>
                        </div>
                        <div className="view-dropdown-control-container
                                view-filter-text">
                            <span className={classNames(
                                'view-dropdown-control',
                                !isFilterApplied? 'filter-no-action': '',
                                disable? 'disable-filter': '')}
                                onClick={isFilterApplied && !disable?
                                    ()=> setAddFilter(true): ()=> null}>
                                Add Filter</span>
                        </div>
                    </div>
                    <div className="view-dropdown-list-container">
                        <span className="view-saved-filter-text">SAVED FILTERS</span>
                        {views.map((view)=> {
                            return (
                                <div key={`view-${view.id}`}
                                    className={classNames(
                                        'view-dropdown-filter-item',
                                        view.id === filterApplied.id? 'selected': '')}
                                    onMouseEnter={()=> setHovered(view.id)}
                                    onMouseLeave={()=> setHovered(0)}
                                    onClick={()=> handleApplyView(view.id)}>
                                    <span className='view-dropdown-filter-name'>
                                        {view.name}
                                    </span>
                                    <span className="view-dropdown-filter-control">
                                        <DeleteIcon width={14} height={14}
                                            onClick={(e)=>
                                                handleDeleteClick(e, view.id)}
                                            fill={hovered === view.id?
                                                'rgba(255, 48, 20, 1)': 'rgba(0, 0, 0, 0.4)'}
                                            />
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            : null}
            </div>
            <div className="view-filter-controls">
                <span className="view-filter-save-control">
                    <span className={classNames(
                        'view-filter-btn',
                        !isFilterApplied? 'filter-no-action': '',
                        disable? 'disable-filter': '')}
                        onClick={disable?
                            ()=> null: handleSaveExistingView}>Save
                        </span>
                        {loading? <span className="edit-loader"/>: null}
                </span>
                <span className={classNames('view-filter-btn',
                     !isFilterApplied? 'filter-no-action': '',
                     disable? 'disable-filter': '')}
                    onClick={disable? ()=> null: clearView}>Clear All</span>
            </div>
        </div></>
    )

}